import { defineStore } from 'pinia'
import useGet from '../core/composables/api/useGet'
import { ref, type Ref } from 'vue'

export const useAvatarStore = defineStore('avatars', {
  state: () => ({
    _avatarUrls: new Map<string, Ref<null | string>>(),
  }),
  actions: {
    getAvatarForMember(id: string, lastUpdatedAvatar?: string) {
      if (!lastUpdatedAvatar) {
        return ref(null)
      }
      const key = id + lastUpdatedAvatar

      if (this._avatarUrls.has(key)) {
        return this._avatarUrls.get(key)!
      }

      const urlRef = ref(null)
      this._avatarUrls.set(key, urlRef)

      this.loadAvatar(id, lastUpdatedAvatar)

      return urlRef
    },
    resetMemberId(memberId: string) {
      this._avatarUrls.delete(memberId)
    },
    async loadAvatar(memberId: string, lastUpdatedAvatar: string) {
      const { data: avatarImage, load } = useGet<Blob>(
        'avatar/' + memberId + '?d=' + lastUpdatedAvatar,
        { responseType: 'arraybuffer' },
      )

      await load()

      if (avatarImage.value.size === 0) {
        return
      }
      const key = memberId + lastUpdatedAvatar

      const url = await URL.createObjectURL(avatarImage.value)
      this._avatarUrls.get(key)!.value = url
    },
  },
})
